import React from 'react';
import {siteNav} from "../../../app-bar/SiteNavigation";
import SectionAppBar from "../SectionAppBar";

const navSection = siteNav.find(n => n.key === "explore");
function ExploreAppBar(props) {
  return <SectionAppBar {...props} navSection={navSection} />;
}

export default ExploreAppBar
